import { IWidgetConfiguration } from '../../widgets';
import { ConnectionPoint } from '../../models';

export class ConnectionPointConfiguration implements IWidgetConfiguration {
    connectionPoint: IConnectionPointCreation;
    minimum: boolean;
    isDefault: boolean;
    hasTags: boolean;
    isUpdatable: boolean;
    isLoadingNeedUpdate: boolean;
    needUpdate: boolean;
    needConfiguration: boolean;
    isAvailable: boolean;
    name?: string;
}

export interface IConnectionPointCreation extends ConnectionPoint {
    isDatabaseCreationRequested?:boolean;
}